/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ComponentInterface } from '../../canvas-common/interfaces/component.interface';
import { TicketContainer } from '@appPlanApplication/tickets/TicketContainer';
import { FancySprite } from '@appCanvasCommon/graphics/FancySprite';
import { Texture } from 'pixi.js-legacy';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
/**
 *
 */
export abstract class TicketComponentHelper extends FancySprite implements ComponentInterface {
	public override visible = true;
	protected ticket: TicketContainer;
	protected canvasAngularLand: CanvasAngularLand;
	constructor(texture: Texture, canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		super(texture);
		this.ticket = ticketContainer;
		this.canvasAngularLand = canvasAngularLand;
	}
}
